import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import IconDelete from "../../component/SvgIcons/IconDelete";
import IconLink from "../../component/SvgIcons/IconLink";
import IconPen from "../../component/SvgIcons/IconPen";
import IconPlus from "../../component/SvgIcons/IconPlus";
import IconSearch from "../../component/SvgIcons/IconSearch";
import IconUpdownFilter from "../../component/SvgIcons/IconUpdownFilter";
import api from "../../Services/api";
import "./style.css"; 
import Iconcloselink from "../../component/SvgIcons/Iconcloselink";
import IconCV from "../../component/SvgIcons/IconCV";
import { formatCountryDate } from "../../Services/countryTime";
Modal.setAppElement("#root");

export default function Events() {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);    
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);  
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 1920) {
          setItemsPerPage(20);
        } else {
          setItemsPerPage(10);
        }
      };
      handleResize(); // Set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  useEffect(() => {
    // Fetch data from the API when the component mounts
    const fetchData = async () => {
      try {
        const response = await api.post("/eventview"); // Update the endpoint as necessary        
        const sortedData = response.data.sort((a, b) => {
          return new Date(b.event_date) - new Date(a.event_date); // Newest first
        });
        setData(sortedData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once when the component mounts

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page on search
  };

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  
    setData((prevData) => {
      return [...prevData].sort((a, b) => {
        if (a[key] < b[key]) return sortConfig.direction === "asc" ? -1 : 1;
        if (a[key] > b[key]) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    });
  };
  

  // Filter data based on search query
const filteredEventData = data.filter((event) =>
  event.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
  event.contents?.toLowerCase().includes(searchQuery.toLowerCase()) || // Filter by contents
  event.event_date.includes(searchQuery) || // Filter by event date
  event.starttime?.includes(searchQuery) || // Filter by start time
  event.endtime?.includes(searchQuery) || // Filter by end time
  event.ModeOfMeeting?.toLowerCase().includes(searchQuery.toLowerCase()) // Filter by ModeOfMeeting
);


  // Calculate indices for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEventData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Pagination handling
  const totalPages = Math.ceil(filteredEventData.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this event?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // Send DELETE request to the API
      await api.post(`/DeleteEvent/${id}`);

      // Remove the deleted event from the state
      setData((prevData) => prevData.filter((event) => event.id !== id));

      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Event deleted successfully.",
      });
    } catch (error) {
      console.error("Error deleting event:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "An error occurred while deleting the event.",
      });
    }
  };  

  return (
    <section className="eventpage">
      <Header pageTitle="Event Details List" />
      <div className="pageLeftspace">
      <div className="d-flex justify-content-between align-items-center topsearchbar">
      <div className="d-flex align-items-center gap-2">
            <Link
              to="/add-events"
              className="btn btn-purpal addbutton"            
            >
              <IconPlus />
              Add Event
            </Link>

             <Link
              to="/event-registration"
              className="btn btn-purpal addbutton"            
            >
              <IconCV/>              
              View Registration
            </Link>

             <Link to="#" onClick={() => handleSort("title")}>
              <IconUpdownFilter/>
            </Link>   
            </div>

            <div className="input-container">
              <input
                type="text"
                id="name"
                value={searchQuery}
                onChange={handleSearchChange}
                 placeholder="Search Here.."
              />
              {/* <label htmlFor="name">Search</label> */}
              <span className="underline"></span>
               <div className="search-icon">
                <IconSearch/>
              </div>
            </div>
          </div>

        <div className="tableheader d-flex flex-column gap-4">        
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10" align="center">
                    Sr. No.
                  </th>
                  <th>Meeting Topic</th>                  
                  <th width="50">Photo</th>
                  <th>Contents</th>
                  <th>Event Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th style={{textAlign:"center"}}>Mode of Meeting</th>
                        <th>Venue</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((event, index) => (
                    <tr key={event.id}>
                    <td align="center">{index + 1}</td>
                      <td title={event.title}>
                      {event.title.length > 40 ? `${event.title.substring(0, 40)}...` : event.title}
                      </td>                     
                      <td>
                        {event.photo ? (
                          <div>
                            {event.photo ? (
                              <a
                                href={`${process.env.REACT_APP_API_PRJ_URL}/uploads/event/${event.photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  className="event-image"
                                  src={`${process.env.REACT_APP_API_PRJ_URL}/uploads/event/${event.photo}`}
                                  width="50"
                                  onError={(e) => {
                                    e.target.style.display = "none"; // Hide the broken image
                                    e.target.parentElement.style.display =
                                      "none"; 
                                    e.target.parentElement.nextElementSibling.style.display =
                                      "inline"; 
                                  }}
                                  alt=""
                                />
                              </a>
                            ) : null}
                            <span
                              style={{
                                display: event.photo ? "none" : "inline",
                              }}
                            >
                           N/A
                            </span>
                          </div>
                        ) : (
                          <span>N/A</span>
                        )}
                        {/* <img className="event-image"
                          src={`${process.env.REACT_APP_API_PRJ_URL}/uploads/event/${event.photo}`}
                          // src={`/uploads/Event/${event.photo}`} // Path to the image
                          // alt={event.title}
                          width="50"
                        /> */}
                      </td>

                      <td title={event.contents}>
                        {event.contents
                          ? event.contents.replace(/<\/?[^>]+(>|$)/g, "")
                              .length > 60
                            ? `${event.contents
                                .replace(/<\/?[^>]+(>|$)/g, "")
                                .substring(0, 60)}...`
                            : event.contents.replace(/<\/?[^>]+(>|$)/g, "")
                          : ""}
                      </td>                      

                      
                        <td>
                          {formatCountryDate(event.event_date)
                            .replace(/\//g, "-")}
                        </td>
                      
                      <td>{event.starttime}</td>
                      <td>{event.endtime}</td>                    
                       <td style={{ textAlign: "center" }}>
                       {event.ModeOfMeeting && (
                        <span
                          className={`status-badge ${                            
                            event.ModeOfMeeting?.toLowerCase() === "online meeting" ? "status-active" : "status-deactive"
                          }`}
                        >
                          {event.ModeOfMeeting}
                        </span>
                      )}
                      </td>
     <td title={event.venue}>
                        {event.venue
                          ? event.venue.replace(/<\/?[^>]+(>|$)/g, "")
                              .length > 30
                            ? `${event.venue
                                .replace(/<\/?[^>]+(>|$)/g, "")
                                .substring(0, 30)}...`
                            : event.venue.replace(/<\/?[^>]+(>|$)/g, "")
                          : ""}
                      </td> 



                      <td>
                        <div className="action">                   
                        {event.link ? (
                          <>
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(event.link, "_blank");
                              }}
                              className="editbtn"
                              data-tooltip-id={`link-${event.id}`}
                              data-tooltip-content="Open Meeting Link"
                            >
                              <IconLink />
                            </Link>
                            <Tooltip id={`link-${event.id}`} place="top" />
                          </>
                       ) : (
                        <>
                       <Link
                        to="#" className="editbtn"
                        data-tooltip-id={`link-${event.id}`}
                        data-tooltip-content="Offline Meeting "
                      >
                        <Iconcloselink />
                        </Link>
                         <Tooltip id={`link-${event.id}`} place="top" />
                         </>
                      )}

                          <Link
                            to={`/edit-event/${event.id}`}
                            className="editbtn"
                            data-tooltip-id={`edit-${event.id}`}
                            data-tooltip-content="Edit"
                          >
                            <IconPen />
                          </Link>
                          <Tooltip id={`edit-${event.id}`} place="top" />

                          <Link to="#" onClick={() => handleDelete(event.id)}
                          data-tooltip-id={`delete-${event.id}`}
                          data-tooltip-content="Delete">                            
                            <IconDelete />
                          </Link>
                          <Tooltip id={`delete-${event.id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="10"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={
              filteredEventData.length > itemsPerPage ? totalPages : 0
            }
            onPageChange={handlePageChange}
          />
        </div>
      </div>
  
    </section>
  );
}
